import { useState, useEffect } from "react";
import { Chip, Button, Container, Grid } from "@mui/material";

import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";

import DataGridCustom from "../components/General/DatagridCustom";
import ActionHeaderCard from "../components/General/ActionHeaderCard";

import { getOperationTypes, syncOperationTypes } from "../services/OperationTypeService";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";

const TYPE_LABEL = {
  lawyer: "Abogado",
  municipality: "Municipalidad",
};

export default function SettingsOperationTypes() {
  const { hasPermission } = useAuth();
  const { showToast } = useToast();

  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getOperationTypes();
      setTypes(res?.data?.data ?? []);
    } catch {
      setError("Error al cargar los tipos de operaciones.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const res = await syncOperationTypes();
      showToast(res?.data?.message || "Catálogo sincronizado.", "success");
      setTypes(res?.data?.data ?? []);
    } catch {
      showToast("Error al sincronizar los tipos de operaciones.", "error");
    } finally {
      setSyncing(false);
    }
  };

  const columns = [
    { field: "name", headerName: "Tipo de operación", flex: 1, minWidth: 320 },
    {
      field: "type", headerName: "Clasificación", width: 160,
      renderCell: ({ value }) => (
        <Chip
          label={TYPE_LABEL[value] || value}
          size="small"
          color={value === "lawyer" ? "primary" : "secondary"}
          variant="outlined"
          sx={{ fontSize: 11, height: 22, fontWeight: 700 }}
        />
      ),
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <ActionHeaderCard
            icon={<GavelRoundedIcon />}
            title="Tipos de Operaciones"
            description="Catálogo de los tipos que puede tomar una operación de expediente, clasificados según su origen (abogado o municipalidad)."
            action={
              hasPermission("administrar tipos operaciones") ? (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<SyncRoundedIcon />}
                  onClick={handleSync}
                  disabled={syncing}
                >
                  {syncing ? "Sincronizando..." : "Sincronizar"}
                </Button>
              ) : null
            }
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <DataGridCustom rows={types} columns={columns} loading={loading} error={error} />
        </Grid>
      </Grid>
    </Container>
  );
}
